import { LitElement } from "lit";
//#region src/base/pd-base-ui.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*
* Abstract base lit class for all pd-form elements.
* Import shared-global-style to make common custom properties available to all components.
*
* Used from:
* - pd-base-ui-input
*
* Used to:
* - define css (import shared-global-styles.js)
* - define common properties (detailieren, aktuell keine)
* - define updateWhenLocaleChanges for all pd-elements (check, aktuell nur für pd-form-container benötigt)
*
* Custom Properties (shared-global-styles):
* ... TODO
*/
/**
* Basisklasse für alle pd-* UI-Komponenten.
*
* - Importiert globale Farben und Schriftarten
* - Reagiert automatisch auf Sprachwechsel durch `@localized()`
* - Dient als gemeinsame Basisklasse für Formulare, Container etc.
*/
var PdBaseUI = class extends LitElement {
	static {
		this.styles = [];
	}
};
//#endregion
export { PdBaseUI };
